
import "./medical.css";

import Header from "../../../components/Header";    
import Footer from "../../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";

/* banco de dados */
import { db } from "../../../services/firebaseConnection";
import { collection, addDoc, doc, updateDoc, query, where, getDoc, getDocs, limit } from "firebase/firestore";

import { useForm } from "react-hook-form";

/* redux */
import { useDispatch, useSelector } from "react-redux";
import {  updateAgent } from "../../../redux/agent/slice";

/* navegação */
import { useNavigate } from "react-router-dom";

/* validação de campos */
import { masktelefone, maskcep } from "../../../services/masks/masks.ts";

/* funções auxiliares */
import { registerLog, showError, clearError, formError } from "../../../services/functions/functions.ts";

/* imagens */
import icon_success from "../../../assets/sucesso.png";

/* uuis automáticos*/
import { v4 as uuidv4 } from "uuid";


export default function Medical() {

    /*
    1 - dados da clínica
    2 - médico, especialidades, consulta e convênios
    3 - exames
    4 - agenda
    5 - finalizar
    */

    const [step, setStep] = useState(0);
    const [error, setError] = useState("0");
    const [telefone, setTelefone] = useState("");

    const [load, setLoad] = useState(true);

    const [exames, setExames] = useState([]);
    const [agenda, setAgenda] = useState(Array.from({ length: 7 * 24 }, (_, index) => { const dia = Math.floor(index / 24); const hora = index % 24; return { dia, hora, disponivel: false }; }));

    const [convenio, setConvenio] = useState(false);
    const [selectedConvenios, setSelectedConvenios] = useState([]);


    /* referências para tratativa de erros */
    //tela 1 - clinica
    const refDescription = useRef(null);
    const refLabelDescription = useRef(null);
    const refErrorDescription = useRef(null);

    const refCep = useRef(null);
    const refLabelCep = useRef(null);
    const refErrorCep = useRef(null);

    const refLogradouro = useRef(null);
    const refLabelLogradouro = useRef(null);
    const refErrorLogradouro = useRef(null);

    const refNumero = useRef(null);
    const refLabelNumero = useRef(null);

    const refMunicipio = useRef(null);
    const refLabelMunicipio = useRef(null);
    const refErrorMunicipio = useRef(null);

    const refUf = useRef(null);
    const refLabelUf = useRef(null);

    const refSite = useRef(null);
    const refLabelSite = useRef(null);
    const refErrorSite = useRef(null);

    const refInsta = useRef(null);
    const refLabelInsta = useRef(null);

    const refTelefone = useRef(null);
    const refLabelTelefone = useRef(null);
    const refErrorTelefone = useRef(null);

    //tela 2 - médico
    const refMedico = useRef(null);
    const refLabelMedico = useRef(null);
    const refErrorMedico = useRef(null);

    const refEspecialidade = useRef(null);
    const refLabelEspecialidade = useRef(null);
    const refErrorEspecialidade = useRef(null);

    const refValor = useRef(null);
    const refLabelValor = useRef(null);
    const refErrorValor = useRef(null);

    const refConvenio = useRef(null);
    const refErrorConvenio = useRef(null);

    const refNumeroConsultas = useRef(null);
    const refLabelNumeroConsultas = useRef(null);
    const refErrorNumeroConsultas = useRef(null);

    const refCheckBox = useRef(null);

    //tela 3 - exames
    const refExame = useRef(null);
    const refLabelExame = useRef(null);
    const refErrorExame = useRef(null);

    const refValorExame = useRef(null);
    const refLabelValorExame = useRef(null);

    //tela 4 - calendário
    const refErrorAgenda = useRef(null);
    const refButtonConcluir = useRef(null);
    const refError = useRef(null);

    /* --- */

    const { user } = useSelector((rootReducer) => rootReducer.user);
    const { agent } = useSelector((rootReducer) => rootReducer.agent);

    const { handleSubmit, register, setValue, getValues, watch } = useForm();

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const [isPending, startTransition] = useTransition();

    const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const dias = Array.from({ length: 7 }, (_, d) => agenda.filter(item => item.dia === d));

    const marcar_agenda = (dia, hora) => {setAgenda(prev => prev.map(item => item.dia === dia && item.hora === hora ? {...item, disponivel: !item.disponivel} : item)); refErrorAgenda.current.innerHTML = ""; refErrorAgenda.current.style.height = "0";};

    useEffect(() => { window.scrollTo(0, 0); }, []);

    const handleChange = (event) => { 
        
        const nv = event.target.value === "true"
        setConvenio(nv);

        if(nv) {

            refConvenio.current.style.backgroundColor = "var(--BAS_2)";
            refConvenio.current.disabled = false;
            refNumeroConsultas.current.disabled = false;

        } else {

            refConvenio.current.style.backgroundColor = "rgb(240, 240, 240)";
            refConvenio.current.disabled = true;
            refNumeroConsultas.current.disabled = true;
            setValue("numero_consultas", 0);
            setSelectedConvenios([]);

        }

    };

    const handleConvenioToggle = (nome) => {setSelectedConvenios((prev) => prev.includes(nome) ? prev.filter((item) => item !== nome) : [...prev, nome]);};

    
    useEffect(() => {

        async function loadclient() {

            try {

                setValue("empresa", user.empresa);
                setValue("numero_consultas", 0);

                //adicionar rotina para alteração de agente, status = 4

                setLoad(false);

            }
            catch(erro) {
                alert(erro);
            }

        }

        loadclient();

    }, [])
    


    function medical_step1(e) {

        e.preventDefault();

        let ds = getValues("description");
        if(ds.length < 10) {
            showError(refDescription, refLabelDescription, refErrorDescription, "Insira alguma descrição para que seu agente atue melhor", setError, "description");
            return;
        }

        let cp = getValues("cep");
        if(cp.length < 9) {
            showError(refCep, refLabelCep, refErrorCep, "Insira um CEP com oito caracteres", setError, "cep");
            return;
        }

        let lg = getValues("logradouro");
        if(lg.length < 5) {
            showError(refLogradouro, refLabelLogradouro, refErrorLogradouro, "Insira o logradouro do endereço", setError, "logradouro");
            return;
        }

        let nu = getValues("numero");
        if(nu.length === 0) {
            showError(refNumero, refLabelNumero, refErrorLogradouro, "Insira o número do logradouro do endereço", setError, "numero");
            return;
        }

        let mu = getValues("municipio");
        if(mu.length < 3) {
            showError(refMunicipio, refLabelMunicipio, refErrorMunicipio, "Insira o nome do Município do endereço", setError, "municipio");
            return;
        }

        let uf = getValues("uf");
        if(uf.length < 2) {
            showError(refUf, refLabelUf, refErrorMunicipio, "Insira a sigla da UF do endereço", setError, "uf");
            return;
        }

        let st = getValues("site");
        if(st.length > 0) {
            const rsite = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/.*)?$/i;
            if(!rsite.test(st)) {
                showError(refSite, refLabelSite, refErrorSite, "Insira uma URL de web site válida", setError, "site");
                return;
            }
        }

        let ig = getValues("instagram");
        if(ig.length > 0 && ig === "@") {
            showError(refInsta, refLabelInsta, refErrorSite, "Esse endereço de Instagram não é válido", setError, "instagram");
            return;
        }

        let tl = getValues("telefone_humano");
        if(tl.length > 0 && tl.length < 15) {
            showError(refTelefone, refLabelTelefone, refErrorTelefone, "Número de telefone incorreto, insira DDD + telefone", setError, "telefone_humano");
            return;
        }

        registerLog(user.id, "/configure_agent/step1/id=" + agent.id);

        setStep(1);
        window.scrollTo(0, 0);

    }



    function medical_step2(e) {

        e.preventDefault();

        let md = getValues("medico");
        const v_nome = (nome) => { let validade = /\b[A-Za-zÀ-ú][A-Za-zÀ-ú]+,?\s[A-Za-zÀ-ú][A-Za-zÀ-ú]{2,19}\b/gi; return validade.test(nome); }
        if(!v_nome(md)) {
            showError(refMedico, refLabelMedico, refErrorMedico, "Insira o nome do médico completo", setError, "medico");
            return;
        }

        let ep = getValues("especialidade");
        if(ep.length < 10) {
            showError(refEspecialidade, refLabelEspecialidade, refErrorEspecialidade, "Insira alguma especialidade ou fato relevante para que seu agente atue melhor", setError, "especialidade");
            return;
        }

        let vl = getValues("valor").replace(",", ".");
        if(vl.length === 0 || isNaN(Number(vl))) {
            showError(refValor, refLabelValor, refErrorValor, "Insira um valor válido em reais para sua consulta", setError, "valor");
            return;
        }
        
        registerLog(user.id, "/configure_agent/step2/id=" + agent.id);

        setStep(2);
        window.scrollTo(0, 0);

    }



    function medical_step3() {

        registerLog(user.id, "/configure_agent/step3/id=" + agent.id);
        setStep(3);
        window.scrollTo(0, 0);

    }



    async function configure_agent(data) {

        const dsp = agenda.some(item => item.disponivel);
        if(dsp === false) {
            refErrorAgenda.current.innerHTML = "Você precisa selecionar ao menos um dia-horário para continuar.";
            refErrorAgenda.current.style.height = "1.5rem";
            return
        }
        
        startTransition( async() => {
        try {

            let uid = user.id;
            let aid = agent.id;
            let apl = agent.plano;

            refButtonConcluir.current.innerHTML = "AGUARDE ... testando apis";

            const testapi = await test_apis();

            if(testapi.error) {
                formError(refError, JSON.stringify("As APIs de serviço estão temporarimente indisponíveis, tente novamente mais tarde por favor. " + testapi.description), true);
                return;
            } 

            await wait(1000);

            //começa o feedback para o cliente na legenda dos botões
            refButtonConcluir.current.innerText = "AGUARDE ... registrando dados";

            //registra os dados
            let dt_atual = new Date();
        
            await addDoc(collection(db, "medical"), 
            { 
                id_client: uid,
                id_agent: aid,
                codigo_plano: apl,
                data_criacao: dt_atual,
                data_inicio_vigencia: dt_atual,
                data_termino_vigencia: new Date("2100-12-31T23:59:59Z"),
                empresa: data.empresa,
                descricao: data.description,
                cep: data.cep,
                logradouro: data.logradouro,
                numero: data.numero,
                complemento: data.complemento,
                bairro: data.bairro,
                municipio: data.municipio,
                uf: data.uf,
                site: data.site,
                instagram: data.instagram,
                telefone_humano: data.telefone_humano,
                medico: data.medico,
                crm: data.crm,
                especialidade: data.especialidade,
                valor: data.valor,
                exames: exames,
                agenda: agenda,
            })

            await wait(1000);

            refButtonConcluir.current.innerText = "AGUARDE ... verificando disponibilidade";

            //verifica qual linha está disponível
            const telephonedb = collection(db, "telephones");
            const telephonequery = query(telephonedb, where("status", "==", 1), limit(1));

            const telephonedoc = await getDocs(telephonequery);
            if(telephonedoc.size === 0) {
                
                //sem linha disponível
                const agentref = doc(db, "agents", aid);
                await updateDoc(agentref, { status: 2, status_motivo: "não há linha disponivel"});

                //atualiza sessão e redux
                sessionStorage.setItem('status', JSON.stringify(2));

                dispatch(updateAgent({
                    id: agent.id,
                    nome: agent.nome,
                    plano: agent.plano,
                    status: 2,
                }))

                alert("não há linha disponível");

                //atualiza a tela e informa ao cliente

            }
            else {
                
                let idtel = telephonedoc.docs[0].id;
                let tel = telephonedoc.docs[0].data().telefone;
                let idgpt = telephonedoc.docs[0].data().id_gptmaker;
                let idagd = telephonedoc.docs[0].data().id_agenda;

                await wait(1000);
                refButtonConcluir.current.innerText = "AGUARDE ... alocando linha";

                const mk_ln = await make_line(idtel);

                if(mk_ln.error) {

                    //atualiza a tela e informa ao cliente
                    alert(mk_ln.description);
                    return;

                }

                setTelefone(tel);

                await wait(1000);
                refButtonConcluir.current.innerText = "AGUARDE ... atualizando dados";

                const up_ag = await update_agent(agent.id, dt_atual, idtel, tel);

                if(up_ag.error) {

                    //atualiza a tela e informa ao cliente
                    alert(up_ag.description);
                    return;

                }

                await wait(2000);

                refButtonConcluir.current.innerText = "AGUARDE ... configurando agente";

                const cr_ag = await create_agentgpt(idgpt);
                
                if(cr_ag.error) {

                    //atualiza a tela e informa ao cliente
                    alert(cr_ag.description);
                    return;

                };

                await wait(2000);

                refButtonConcluir.current.innerText = "AGUARDE ... compartilhando agenda";

                const sh_cl = await share_calendar(idagd, user.email);
                
                if(sh_cl.error) {

                    //atualiza a tela e informa ao cliente
                    alert(sh_cl.description);
                    return;

                };

                await wait(1000);

                registerLog(user.id, "/configure_agent/success/id=" + agent.id);
                setStep(4);
                window.scrollTo(0, 0);

            }
        
        } 
        catch(erro) {
            alert("principal " + erro);
        }
        })
        
    }



    async function test_apis() {

        try {

            const resCalendar = await fetch("https://share-calendar-712108985873.southamerica-east1.run.app/ping");
            const dataCalendar = await resCalendar.json();

            if(dataCalendar.status !== "ok") {
                return { error: true, description: dataCalendar.message };
            }

            const resGptMaker = await fetch("https://gptmaker-service-712108985873.southamerica-east1.run.app/ping");
            const dataGptMaker = await resGptMaker.json();

            if(dataGptMaker.status !== "ok") {
                return { error: true, description: dataGptMaker.message };
            }
            
            return { error: false, description: "" };

        }
        catch(erro) {
            return { error: true, description: "test_apis " + erro };
        }
        
    }


    async function make_line(idtel) {

        try {

            const telephoneref = doc(db, "telephones", idtel);
            await updateDoc(telephoneref, { status: 2 });

            return { error: false, description: "" };

        } 
        catch (erro) {
            return { error: true, description: "make_line " + erro };
        }

    }



    async function update_agent(idagent, dt_atual, idtel, tel) {
        
        try {
        
            const agentref = doc(db, "agents", idagent);
            await updateDoc(agentref, { data_inicio_ativacao: dt_atual, data_termino_ativacao: new Date("2100-12-31T23:59:59Z"), status: 3, telefone: tel })

            const dagent = await getDoc(agentref);

            let id_client = dagent.data().id_client;
            let plano = dagent.data().plano;

            await addDoc(collection(db, "uses"), 
            { 
                id_client: id_client,
                id_agent: idagent,
                id_telephone: idtel,
                plano: plano,
                data_criacao: dt_atual,
                data_inicio_vigencia: dt_atual,
                data_termino_vigencia: new Date("2100-12-31T23:59:59Z"),
            })

            sessionStorage.setItem('status', JSON.stringify(3));

            dispatch(updateAgent({
                id: agent.id,
                nome: agent.nome,
                plano: agent.plano,
                status: 3,
            }))

            return { error: false, description: "" };

        }
        catch(erro) {
            return { error: true, description: "erro update_agent " + erro };
        }

    }


    async function create_agentgpt(idagentgpt) {

        try {

            let endereço = "\n\nEndereço:\nLogradouro: " + getValues("logradouro") + ", Número: " + getValues("numero") + (getValues("complemento").length > 0 ? ", Complemento: " + getValues("complemento") : "") + ", Bairro: " + getValues("bairro") + ", Cidade: " + getValues("municipio") + ", Estado: " + getValues("uf") + "\nCEP: " + getValues("cep");
            let medico = "\n\nMédico:\nNome: " + getValues("medico") + (getValues("crm").length > 0 ? ", CRM: " + getValues("crm") : "") + "\nSobre o Médico: " + getValues("especialidade");
            let consulta = "\n\nConsulta:\nValor: R$ " + getValues("valor");
            
            let lista_exames = "";
            if(exames.length > 0) {
                lista_exames = "\n\nEXAMES:";
                for(let i = 0; i < exames.length; i++) {
                    lista_exames = lista_exames + "\nNome: " + exames[i].exame + "\nValor: R$ " + exames[i].valor + (exames[i].descricao.length > 0 ? "\nObservações : " + exames[i].descricao : "") + "\n";
                }
            }

            const tabela_agenda = monta_agenda();
            
            const resGptMaker = await fetch("https://gptmaker-service-712108985873.southamerica-east1.run.app/gptmaker/update_agent", { method: "POST", headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id: idagentgpt,
                    name: agent.nome,
                    behavior: "Você é um agente que trabalha numa clínica médica, sua função é atender os clientes e informar sobre a empresa, os médicos, marcar e remarcar consultas." + endereço + medico + consulta + lista_exames + tabela_agenda,
                    jobdescription: getValues("description")
                })
            });
           
            if(resGptMaker.status === 200) {
                return { error: false, description: "" };
            } 

        }
        catch (error) {
            if (error.response) {
                return { error: true, description: "API GptMaker Erro - " + error.response.data };
            } else {
                return { error: true, description: "API GptMaker Falha - " + error.message };
            }
        }
 
    }



    async function share_calendar(idagenda, pemail) {
        
        try {

            const resCalendar = await fetch("https://share-calendar-712108985873.southamerica-east1.run.app/share", { method: "POST", headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    id_agenda: idagenda,
                    email: pemail
                })
            });
           
            if(resCalendar.status === 200) {
                return { error: false, description: "" };
            } 

        }
        catch (error) {
            if (error.response) {
                return { error: true, description: "API Calendar Erro - " + error.response.data };
            } else {
                return { error: true, description: "API Calendar Falha - " + error.message };
            }
        }

    }



    async function find_address() {

        let cp = getValues("cep");
        if(cp.length < 9) {
            setError("cep");
            setValue("logradouro", "");
            setValue("bairro", "");
            setValue("municipio", "");
            setValue("uf", "");
            showError(refCep, refLabelCep, refErrorCep, "Insira um CEP com oito digitos", setError, "cep");
            return;
        }

        startTransition( async() => {
        try {

            cp = cp.replace('-', '');
            const rcep = await fetch(`https://viacep.com.br/ws/${cp}/json/`);
            
            rcep.json().then(data => {

            if(data.erro === "true") {
                setValue("logradouro", "");
                setValue("bairro", "");
                setValue("municipio", "");
                setValue("uf", "");
                setError("cep");
                showError(refCep, refLabelCep, refErrorCep, "Esse CEP não foi localizado, verifique a digitação", setError, "cep");
            } else {
                setValue("logradouro", data.logradouro);
                setValue("bairro", data.bairro);
                setValue("municipio", data.localidade);
                setValue("uf", data.uf);
                refNumero.current.focus();
            }

            });

        }
        catch(erro) {
            console.log(erro);
        }
        })
        
    }

    function vinsta(e) {
        if (e.length >0 && !e.startsWith("@")) {
            setValue("instagram", "@" + e.replace(/@/g, ""));
        }
    }

    
    function back_step(stp) {

        setStep(stp);
        window.scrollTo(0, 0);

    }
    

    function add_exame() {

        let ne = getValues("exame");
        if(ne.length < 3) {
            showError(refExame, refLabelExame, refErrorExame, "Você deve inserir um nome para seu exame", setError, "exame");
            return;
        }

        let ve = getValues("valor_exame").replace(",", ".");
        if(ve.length === 0 || isNaN(Number(ve))) {
            showError(refValorExame, refLabelValorExame, refErrorExame, "Insira um valor válido em reais para seu exame", setError, "exame_valor");
            return;
        }

        let de = getValues("descricao_exame");

        setExames(ex => [...ex, {id: uuidv4(), exame: ne, valor: Number(ve).toFixed(2), descricao: de}]);

        setValue("exame", "");
        setValue("valor_exame", "");
        setValue("descricao_exame", "");
        refExame.current.focus();
        
    }


    function remove_exame(id) {

        setExames(prev => prev.filter(exame => exame.id !== id));

    }



    function monta_agenda() {
    
        const semana = ["Segunda-Feira", "Terça-Feira", "Quarta-Feira", "Quinta-Feira", "Sexta-Feira", "Sábado", "Domingo"];

        const calendario = semana.map((diaNome, d) => {
            const horasDisponiveis = agenda
                .filter(item => item.dia === d && item.disponivel)
                .map(item => item.hora)
                .sort((a, b) => a - b);

        if (!horasDisponiveis.length) return { dia: diaNome, disponivel: "não disponível" };

        const intervalos = horasDisponiveis.reduce((acc, hora) => {
            if (!acc.length) {
                acc.push({ inicio: hora, fim: hora });
            } else {
                const ultimo = acc[acc.length - 1];
                if (hora === ultimo.fim + 1) {
                    ultimo.fim = hora;
                } else {
                    acc.push({ inicio: hora, fim: hora });
                }
            }
            return acc;
        }, []);

            const intervalosStr = intervalos
                .map(interv => {
                 const pad = n => n.toString().padStart(2, "0");
                    return `${pad(interv.inicio)}:00 às ${pad(interv.fim + 1)}:00`;
                })
                .join(" e ");

            return { dia: diaNome, disponivel: intervalosStr };

        });

        return "\n\nAGENDA:\nVocê só poderá marcar ou remarcar uma consulta dentro desses dias e horários específicos, conforme a tabela abaixo:\n" + calendario.map(c => `${c.dia} = ${c.disponivel}`).join("\n");

    }



    return(

        <div className="context">
        
            <Header access={1}></Header>
        
            <div className="content">

                { step === 0 && 
                (
                <>
                <div className="ft_topico">Configurar agente</div>
                <div className="ft_descricao">Chegou a hora de configurar seu agente, essa é uma etapa muito importante, aqui você definirá todas as regras para que seu agente possa dar o melhor atendimento a seus clientes.</div>
                <div className="space"></div>

                <div className="border_form medical_border_form">
                    <form className="form">

                        <span className="step_form">
                            <span className="step_form_number">Passo 1/4</span>
                            <span className="step_form_description">&nbsp;. Informações Gerais</span>
                        </span>
                    
                        <span className="space_form"></span>

                        <span className="title_form">Clínica ou local de atendimento</span>
                        <span className="subtitle_form">Informações cadastradas sobre a clínica ou local de atendimento do médico.</span>
                        
                        <label for="inp" className="inp">
                        <input type="text" placeholder="&nbsp;" {...register("empresa")} disabled={true}></input>
                        <span className="label">Empresa</span>
                        <span className="focus-bg"></span>
                        </label>
                        <span className="space_form"></span>

                        <span className="subtitle_form">Descreva as especialidades da clínica ou fatores que você julgue relevantes para que seus clientes saibam.</span>
                        <span className="subtitle_form">O agente fornecerá essas qualificações a seus clientes.</span>
                        
                        <span ref={refErrorDescription} className="error_form"></span>
                        <label for="inp2" className="inp2" ref={refLabelDescription}>
                        <textarea placeholder="&nbsp;" {...register("description")} maxLength={400} ref={(el) => {refDescription.current = el; register("description").ref(el);}} onClick={() => clearError(refDescription, refLabelDescription, refErrorDescription, error, setError)} onChange={() => clearError(refDescription, refLabelDescription, refErrorDescription, error, setError)}></textarea>
                        <span class="label2">Especialidades e pontos relevantes</span>
                        <span class="focus-bg2"></span>
                        </label>
                        <span className="space_form"></span>

                        <span className="title_form">Endereço</span>
                        <span className="subtitle_form">O agente fornecerá sempre que perguntado o endereço.</span>
                        <span className="medical_observacao">Para facilitar, digite o CEP e clique em "buscar endereço".</span>
                
                        <span ref={refErrorCep} className="error_form"></span>
                        <div className="medical_box01">

                            <div className="medical_box01a">
                                <label for="inp" className="inp" ref={refLabelCep}>
                                <input type="text" placeholder="&nbsp;" maxLength={9} {...register("cep")} onKeyDown={(e) => {if (e.key === "Enter") {find_address();}}} ref={(el) => {refCep.current = el; register("cep").ref(el);}} onClick={() => clearError(refCep, refLabelCep, refErrorCep, error, setError)} onChange={(e) => {if (error === "0") {setValue("cep", maskcep(e.target.value));} else {clearError(refCep, refLabelCep, refErrorCep, error, setError);}}}></input>
                                <span className="label">CEP</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                            <div className="medical_box01b"></div>

                            <div className="medical_box01c">
                                <button type="button" name="bt1" className={ isPending ? "buttonsearch_disabled_form" : "buttonsearch_form" } onClick={ find_address }>{ isPending ? "AGUARDE ..." : "BUSCAR ENDEREÇO" }</button>
                            </div>

                            <div className="medical_box01d"></div>

                        </div>
                        <span className="space_form"></span>

                        <span ref={refErrorLogradouro} className="error_form"></span>
                        <div className="medical_box">

                            <div className="medical_box02a">
                            <label for="inp" className="inp" ref={refLabelLogradouro}>
                            <input type="text" placeholder="&nbsp;" maxLength={60} {...register("logradouro")} ref={(el) => {refLogradouro.current = el; register("logradouro").ref(el);}} onClick={() => clearError(refLogradouro, refLabelLogradouro, refErrorLogradouro, error, setError)} onChange={() => clearError(refLogradouro, refLabelLogradouro, refErrorLogradouro, error, setError)}></input>
                            <span className="label">Logradouro</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                            <div className="medical_box02b"></div>

                            <div className="medical_box02c">
                            <label for="inp" className="inp" ref={refLabelNumero}>
                            <input type="text" placeholder="&nbsp;" maxLength={8} {...register("numero")} ref={(el) => {refNumero.current = el; register("numero").ref(el);}} onClick={() => clearError(refNumero, refLabelNumero, refErrorLogradouro, error, setError)} onChange={() => clearError(refNumero, refLabelNumero, refErrorLogradouro, error, setError)}></input>
                            <span className="label">Número</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                        </div>
                        <span className="space_form"></span>

                        <span ref={refErrorMunicipio} className="error_form"></span>
                        <div className="medical_box">

                            <div className="medical_box02a">
                            <label for="inp" className="inp">
                            <input type="text" id="bairro" placeholder="&nbsp;" maxLength={30} {...register("bairro")}></input>
                            <span className="label">Bairro</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                            <div className="medical_box02b"></div>

                            <div className="medical_box02c">
                            <label for="inp" className="inp">
                            <input type="text" id="complemento" placeholder="&nbsp;" maxLength={15} {...register("complemento")}></input>
                            <span className="label">Complemento</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                        </div>
                        <span className="space_form"></span>

                        <div className="medical_box">

                            <div className="medical_box02a">
                            <label for="inp" className="inp" ref={refLabelMunicipio}>
                            <input type="text" placeholder="&nbsp;" maxLength={30} {...register("municipio")} ref={(el) => {refMunicipio.current = el; register("municipio").ref(el);}} onClick={() => clearError(refMunicipio, refLabelMunicipio, refErrorMunicipio, error, setError)} onChange={() => clearError(refMunicipio, refLabelMunicipio, refErrorMunicipio, error, setError)}></input>
                            <span className="label">Município</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                            <div className="medical_box02b"></div>

                            <div className="medical_box02c">
                            <label for="inp" className="inp" ref={refLabelUf}>
                            <input type="text" placeholder="&nbsp;" maxLength={2} {...register("uf")} ref={(el) => {refUf.current = el; register("uf").ref(el);}} onClick={() => clearError(refUf, refLabelUf, refErrorMunicipio, error, setError)} onChange={() => clearError(refUf, refLabelUf, refErrorMunicipio, error, setError)}></input>
                            <span className="label">UF</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>
                            
                        </div>
                        <span className="space_form"></span>

                        <span className="title_form">Web site e redes sociais</span>
                        <span className="subtitle_form">O agente poderá fornecer sempre que perguntado o web site e a rede social da clínica.</span>
                
                        <span ref={refErrorSite} className="error_form"></span>
                        <div className="medical_box">

                            <div className="medical_box02a">
                            <label for="inp" className="inp" ref={refLabelSite}>
                            <input type="text" id="site" placeholder="&nbsp;" maxLength={50} {...register("site")} ref={(el) => {refSite.current = el; register("site").ref(el);}} onClick={() => clearError(refSite, refLabelSite, refErrorSite, error, setError)} onChange={() => clearError(refSite, refLabelSite, refErrorSite, error, setError)}></input>
                            <span className="label">Web Site</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                            <div className="medical_box02b"></div>

                            <div className="medical_box02c">
                            <label for="inp" className="inp" ref={refLabelInsta}>
                            <input type="text" placeholder="&nbsp;" maxLength={30} {...register("instagram")} ref={(el) => {refInsta.current = el; register("instagram").ref(el);}} onClick={() => clearError(refInsta, refLabelInsta, refErrorSite, error, setError)} onChange={(e) => {if (error === "0") {vinsta(e.target.value);} else {clearError(refInsta, refLabelInsta, refErrorSite, error, setError);}}}></input>
                            <span className="label">Instagram</span>
                            <span className="focus-bg"></span>
                            </label>
                            </div>

                        </div>
                        <span className="space_form"></span>

                        <span className="title_form">Transferência para humano</span>
                        <span className="subtitle_form">Em determinadas situções o agente pode não ter a resposta ou a informação necessária, ou simplesmente possa surgir algum tema sensível onde ele poderá direcionar a chamada a um humano para que possa dar um tratamento mais adequado ao paciente.</span>
                        <span className="subtitle_form">Número a ser transferido:</span>

                        <span ref={refErrorTelefone} className="error_form"></span>
                        <div className="medical_box">
                            <div className="medical_box03a">
                                <label for="inp" className="inp" ref={refLabelTelefone}>
                                <input type="text" placeholder="&nbsp;" maxLength={15} {...register("telefone_humano")} ref={(el) => {refTelefone.current = el; register("telefone_humano").ref(el);}} onClick={() => clearError(refTelefone, refLabelTelefone, refErrorTelefone, error, setError)} onChange={(e) => {if (error === "0") {setValue("telefone_humano", masktelefone(e.target.value));} else {clearError(refTelefone, refLabelTelefone, refErrorTelefone, error, setError);}}}></input>
                                <span className="label">Telefone</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="medical_box03b"></div>
                        </div>

                        <span className="space_form"></span>
                        <span className="space_form"></span>
                        <button type="button" name="bt1a" className="button_form" onClick={medical_step1}>AVANÇAR</button>
                    
                    </form>
                </div>                    
                </>
                )}


                { step === 1 &&
                (
                <>
                <div className="ft_topico">Configurar agente</div>
                <div className="ft_descricao">Chegou a hora de configurar seu agente, essa é uma etapa muito importante, aqui você definirá todas as regras para que seu agente possa dar o melhor atendimento a seus clientes.</div>
                <div className="space"></div>

                <div className="border_form medical_border_form">
                    <form className="form">

                        <span className="step_form">
                            <span className="step_form_number">Passo 2/4</span>
                            <span className="step_form_description">&nbsp;. Informações do Médico</span>
                        </span>

                        <span className="space_form"></span>

                        <span className="title_form">Identificação do médico</span>
                        <span className="subtitle_form">Preencha as informações sobre o médico.</span>
                        <span className="subtitle_form">Quanto mais informações você inserir em especialidades e informações relevantes, mais completo seu agente ficará.</span>

                        <span className="error_form" ref={refErrorMedico}></span>
                        <div className="medical_box">

                            <div className="medical_box04a">
                                <label for="inp" className="inp" ref={refLabelMedico}>
                                <input type="text" placeholder="&nbsp;" maxLength={60} {...register("medico")} ref={(el) => {refMedico.current = el; register("medico").ref(el);}} onClick={() => clearError(refMedico, refLabelMedico, refErrorMedico, error, setError)} onChange={() => clearError(refMedico, refLabelMedico, refErrorMedico, error, setError)}></input>
                                <span className="label">Nome do Médico</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                            <div className="medical_box04b"></div>

                            <div className="medical_box04c">
                                <label for="inp" className="inp">
                                <input type="text" placeholder="&nbsp;" maxLength={5} {...register("crm")}></input>
                                <span className="label">CRM (opcional)</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                        </div>

                        <span className="space_form"></span>

                        <span className="error_form" ref={refErrorEspecialidade}></span>
                        <label for="inp2" class="inp2" ref={refLabelEspecialidade}>
                        <textarea placeholder="&nbsp;" {...register("especialidade")} maxLength={400} ref={(el) => {refEspecialidade.current = el; register("especialidade").ref(el);}} onClick={() => clearError(refEspecialidade, refLabelEspecialidade, refErrorEspecialidade, error, setError)} onChange={() => clearError(refEspecialidade, refLabelEspecialidade, refErrorEspecialidade, error, setError)}></textarea>
                        <span class="label2">Especialidades e Informações Relevantes</span>
                        <span class="focus-bg2"></span>
                        </label>
                            
                        <span className="space_form"></span>

                        <span className="title_form">Consulta</span>
                        <span className="subtitle_form">Indique o valor da sua consulta, caso seja agendado na modalidade particular.</span>

                        <span className="error_form" ref={refErrorValor}></span>
                        <div className="medical_box">
                            <div className="medical_box05a">
                                <label for="inp" className="inp" ref={refLabelValor}>
                                <input type="text" placeholder="&nbsp;" maxLength={8} {...register("valor")} ref={(el) => {refValor.current = el; register("valor").ref(el);}} onClick={() => clearError(refValor, refLabelValor, refErrorValor, error, setError)} onChange={() => clearError(refValor, refLabelValor, refErrorValor, error, setError)} onKeyDown={(e) => {if (!/[0-9,]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {e.preventDefault();}}}></input>
                                <span className="label">Valor (R$)</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="medical_box05b"></div>
                        </div>

                        <span className="space_form"></span>

                        <span className="title_form">Convênios</span>
                        <span className="subtitle_form">Caso aceite convênios, clique em 'selecionar convênios' e marque todos os convênios que você aceita.</span>

                        <div className="medical_convenio_box">
                            <div className="medical_convenio_option">
                                <input type="radio" name="radio_convenio" value="false" className="radio_custom" checked={convenio === false} onChange={handleChange}></input>
                                <span className="medical_convenio_option_text">Não aceito convênios</span>
                            </div>
                            <div className="medical_convenio_option">
                                <input type="radio" name="radio_convenio" value="true" className="radio_custom" checked={convenio === true} onChange={handleChange}></input>
                                <span className="medical_convenio_option_text">Selecionar convênios</span>
                            </div>
                        </div>
                        <span className="space_form"></span>

                        <div ref={refConvenio} className="medical_convenio_frame">
                            <div className="medical_convenio_itens">
                                <div className="medical_convenio_item"><input type="checkbox" className="checkbox_default" disabled={!convenio} checked={selectedConvenios.includes("Amil")} onChange={() => handleConvenioToggle("Amil")}></input><span className="medical_convenio_item_text" style={{color: selectedConvenios.includes("Amil") ? "var(--SEC_1)" : "var(--CNZ_2)"}}>Amil</span></div>
                                <div className="medical_convenio_item"><input type="checkbox" className="checkbox_default" disabled={!convenio} checked={selectedConvenios.includes("Saúde Caixa")} onChange={() => handleConvenioToggle("Saúde Caixa")}></input><span className="medical_convenio_item_text" style={{color: selectedConvenios.includes("Saúde Caixa") ? "var(--SEC_1)" : "var(--CNZ_2)"}}>Saúde Caixa</span></div>
                                <div className="medical_convenio_item"><input type="checkbox" className="checkbox_default" disabled={!convenio} checked={selectedConvenios.includes("Cruz Azul Saúde")} onChange={() => handleConvenioToggle("Cruz Azul Saúde")}></input><span className="medical_convenio_item_text" style={{color: selectedConvenios.includes("Cruz Azul Saúde") ? "var(--SEC_1)" : "var(--CNZ_2)"}}>Cruz Azul Saúde</span></div>
                            </div>
                            <div className="medical_convenio_itens">
                                <div className="medical_convenio_item"><input type="checkbox" className="checkbox_default" disabled={!convenio}></input><span className="medical_convenio_item_text">Bradesco Saúde</span></div>
                                <div className="medical_convenio_item"><input type="checkbox" className="checkbox_default" disabled={!convenio}></input><span className="medical_convenio_item_text">Classes Laboriosas</span></div>
                                <div className="medical_convenio_item"><input type="checkbox" className="checkbox_default" disabled={!convenio}></input><span className="medical_convenio_item_text">One Health</span></div>
                            </div>
                        </div>

                        <span className="space_form"></span>
                        <span className="subtitle_form">Caso aceite convênios, você pode restringir o número máximo de consultas conveniadas que você aceita por dia.</span>
                        <span className="subtitle_form">0 = Sem limite de consultas conveniadas por dia.</span>

                        <div className="medical_box">
                            <div className="medical_box05a">
                                <label for="inp" className="inp">
                                <input type="text" placeholder="&nbsp;" maxLength={2} {...register("numero_consultas")} ref={(el) => {refNumeroConsultas.current = el; register("numero_consultas").ref(el);}} onClick={() => clearError(refNumeroConsultas, refLabelNumeroConsultas, refErrorNumeroConsultas, error, setError)} onChange={() => clearError(refNumeroConsultas, refLabelNumeroConsultas, refErrorNumeroConsultas, error, setError)} onKeyDown={(e) => {if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {e.preventDefault();}}} disabled={true}></input>
                                <span className="label">Número de Consultas</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>
                            <div className="medical_box05b"></div>
                        </div>

                        <span className="space_form"></span>
                        <span className="space_form"></span>
                        
                        <div className="medical_buttons_box">
                            <div className="medical_box08a">
                                <button type="button" name="bt2a" className="button2_form" onClick={(e) => back_step(0)}>VOLTAR</button>
                            </div>
                            <div className="medical_box08b"></div>
                            <div className="medical_box08c">
                                <button type="button" name="bt2b" className="button_form" onClick={medical_step2}>AVANÇAR</button>
                            </div>
                        </div>

                    </form>
                </div>
                </>
                )}


                { step === 2 &&
                (
                <>
                <div className="ft_topico">Configurar agente</div>
                <div className="ft_descricao">Chegou a hora de configurar seu agente, essa é uma etapa muito importante, aqui você definirá todas as regras para que seu agente possa dar o melhor atendimento a seus clientes.</div>
                <div className="space"></div>

                <div className="medical">

                <span className="step_form">
                    <span className="step_form_number">Passo 3/4</span>
                    <span className="step_form_description">&nbsp;. Exames</span>
                </span>

                <form className="form">
                    <span className="space_form"></span>

                    <span className="title_form">Lista de Exames</span>
                
                    { exames.length > 0 && (<><span className="medical_descricao">Exames Cadastrados</span></>)}
                    
                    { exames.map(item => (
                        <>
                        <div className="medical_box">

                            <div className="medical_box09a">
                                <label for="inp" className="inp">
                                <input type="text" placeholder="&nbsp;" disabled={true} value={item.exame}></input>
                                <span className="label">Nome do Exame</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                            <div className="medical_box09b"></div>

                            <div className="medical_box09c">
                                <label for="inp" className="inp">
                                <input type="text" placeholder="&nbsp;" disabled={true} value={item.valor}></input>
                                <span className="label">Valor (R$)</span>
                                <span className="focus-bg"></span>
                                </label>
                            </div>

                        </div>

                        <span className="space_form"></span>

                        { item.descricao.length > 0 && (
                        <>
                            <label for="inp2" className="inp2">
                            <textarea placeholder="&nbsp;" disabled={true} value={item.descricao}></textarea>
                            <span class="label2">Observações e Recomendações do Exame</span>
                            <span class="focus-bg2"></span>
                            </label>
                            <span className="space_form"></span>
                        </>)}

                        <div className="medical_box">
                            <div className="medical_box09a"></div>
                            <div className="medical_box09b"></div>
                            <div className="medical_box09c">
                                <button type="button" name="bt3c" className="buttonsearch_form" onClick={() => remove_exame(item.id)}>REMOVER EXAME</button>
                            </div>
                        </div>

                        <span className="space_form"></span>
                        <span className="medical_exames_line"></span>
                        <span className="space_form"></span>

                        </>)
                    )}

                    <span className="medical_descricao">Você pode cadastrar exames, caso queira.</span>
                    <span className="medical_observacao">Caso não realize exames ou não queira cadastrar, basta avançar e pular essa etapa.</span>

                    <span className="error_form" ref={refErrorExame}></span>
                    <div className="medical_box">

                        <div className="medical_box09a">
                            <label for="inp" className="inp" ref={refLabelExame}>
                            <input type="text" placeholder="&nbsp;" maxLength={40} {...register("exame")} ref={(el) => {refExame.current = el; register("exame").ref(el);}} onClick={() => clearError(refExame, refLabelExame, refErrorExame, error, setError)} onChange={() => clearError(refExame, refLabelExame, refErrorExame, error, setError)}></input>
                            <span className="label">Nome do Exame</span>
                            <span className="focus-bg"></span>
                            </label>
                        </div>

                        <div className="medical_box09b"></div>

                        <div className="medical_box09c">
                            <label for="inp" className="inp" ref={refLabelValorExame}>
                            <input type="text" placeholder="&nbsp;" maxLength={10} {...register("valor_exame")} ref={(el) => {refValorExame.current = el; register("valor_exame").ref(el);}} onClick={() => clearError(refValorExame, refLabelValorExame, refErrorExame, error, setError)} onChange={() => clearError(refValorExame, refLabelValorExame, refErrorExame, error, setError)}></input>
                            <span className="label">Valor (R$)</span>
                            <span className="focus-bg"></span>
                            </label>
                        </div>

                    </div>

                    <span className="space_form"></span>
                    
                    <label for="inp2" className="inp2">
                    <textarea placeholder="&nbsp;" {...register("descricao_exame")} maxLength={200} ref={(el) => {refDescription.current = el; register("descricao_exame").ref(el);}} onClick={() => clearError(refDescription, refLabelDescription, refErrorDescription, error, setError)} onChange={() => clearError(refDescription, refLabelDescription, refErrorDescription, error, setError)}></textarea>
                    <span class="label2">Observações e Recomendações do Exame</span>
                    <span class="focus-bg2"></span>
                    </label>
                    
                    <span className="space_form"></span>

                    <div className="medical_box">
                        <div className="medical_box09a"></div>
                        <div className="medical_box09b"></div>
                        <div className="medical_box09c">
                            <button type="button" name="bt3c" className="buttonsearch_form" onClick={add_exame}>ADICIONAR EXAME</button>
                        </div>
                    </div>

                    <span className="space_form"></span>
                    <span className="space_form"></span>
                    <span className="space_form"></span>
                    <div className="medical_box">
                        <div className="medical_box08a">
                            <button type="button" name="bt3a" className="button2_form" onClick={(e) => back_step(1)}>VOLTAR</button>
                        </div>
                        <div className="medical_box08b"></div>
                        <div className="medical_box08c">
                            <button type="button" name="bt3b" className="button_form" onClick={medical_step3}>AVANÇAR</button>
                        </div>
                    </div>
                
                </form>
                </div>
                </>
                )}


                { step === 3 &&
                (
                <>
                <div className="ft_topico">Configurar agente</div>
                <div className="ft_descricao">Chegou a hora de configurar seu agente, essa é uma etapa muito importante, aqui você definirá todas as regras para que seu agente possa dar o melhor atendimento a seus clientes.</div>
                <div className="space"></div>

                <div className="medical">

                <span className="step_form">
                    <span className="step_form_number">Passo 4/4</span>
                    <span className="step_form_description">&nbsp;. Agenda</span>
                </span>

                <form className="form" onSubmit={handleSubmit(configure_agent)}>
                    <span className="space_form"></span>

                    <span className="title_form">Defina sua agenda diária</span>
                    <span className="medical_descricao">Defina seus dias e horários de disponibilidade para atendimento clicando no dia-horário específico.</span>

                    <span className="error_form" ref={refErrorAgenda}></span>
                    <div className="medical_calendar_frame">
                        <div className="medical_calendar_column">Segunda</div>
                        <div className="medical_calendar_column">Terça</div>
                        <div className="medical_calendar_column">Quarta</div>
                        <div className="medical_calendar_column">Quinta</div>
                        <div className="medical_calendar_column">Sexta</div>
                        <div className="medical_calendar_column">Sábado</div>
                        <div className="medical_calendar_column">Domingo</div>
                    </div>
                    <div className="medical_calendar_frame">
                        {dias.map((dia, dIndex) => (
                            <div className="medical_calendar_column" key={dIndex}>
                                {dia.map(item => (
                                    <>
                                    <div className="medical_calendar_cell" style={{borderBottom: "solid 1px gray", borderTop: item.hora === 0 ? "solid 1px gray" : "", borderRight: "solid 1px gray", borderLeft: dIndex === 0 ? "solid 1px gray" : "", backgroundColor: item.disponivel ? "yellow" : "white"}} key={item} onClick={() => marcar_agenda(dIndex, item.hora)}>{item.hora === 23 ? "23-00" : String(item.hora).padStart(2, 0) + "-" + String(item.hora + 1).padStart(2, 0)}</div>
                                    </>
                                ))}
                            </div>
                        ))}

                    </div>

                    <span className="space_form"></span>
                    <span className="title_form">Bloqueie um dia ou período específico</span>
                    <span className="medical_descricao">Ao bloquear um dia ou um período específico, o agente indisponibilizará esse intervalo de tempo a seus pacientes.</span>
                    <span className="medical_observacao">Insira o dia inicial para bloquear apenas um dia ou insira dia inicial e final para um período</span>
                        
                    <div className="medical_box">
                        <div className="medical_box10a">
                            <label for="inp" className="inp">
                            <input type="text" placeholder="&nbsp;" maxLength={10} {...register("dia_inicial")}></input>
                            <span className="label">Dia Inicial</span>
                            <span className="focus-bg"></span>
                            </label>
                        </div>
                        <div className="medical_box10b"></div>
                        <div className="medical_box10a">
                            <label for="inp" className="inp">
                            <input type="text" placeholder="&nbsp;" maxLength={10} {...register("dia_final")}></input>
                            <span className="label">Dia Final</span>
                            <span className="focus-bg"></span>
                            </label>
                        </div>
                        <div className="medical_box10b"></div>
                        <div className="medical_box10c">
                            <label for="inp" className="inp">
                            <input type="text" placeholder="&nbsp;" maxLength={10} {...register("motivo")}></input>
                            <span className="label">Motivo</span>
                            <span className="focus-bg"></span>
                            </label>
                        </div>
                        <div className="medical_box10b"></div>
                        <div className="medical_box10d">
                            <div className="medical_box10e">
                                <button type="button" name="bt4c" className={ isPending ? "buttonsearch_disabled_form" : "buttonsearch_form" }>{ isPending ? "AGUARDE ..." : "ADICIONAR" }</button>
                            </div>
                        </div>
                    </div>                        

                    <span className="space_form"></span>
                    <span ref={refError} className="error_form"></span>
                    <span className="space_form"></span>
                    <div className="medical_box">
                        <div className="medical_box08a">
                            <button type="button" name="bt4a" className={ isPending ? "button2_disabled_form" : "button2_form" } onClick={ (e) => back_step(2) } disabled={isPending}>VOLTAR</button>
                        </div>
                        <div className="medical_box08b"></div>
                        <div className="medical_box08c">
                            <button type="submit" ref={refButtonConcluir} name="bt4b" className={ isPending ? "button_disabled_form" : "button_form" } disabled={isPending}>CONCLUIR</button>
                        </div>
                    </div>

                </form>
                </div>
                </>
                )}

                { step === 4 &&
                (
                <>
                <div className="ft_topico">Agente configurado</div>
                <div className="ft_descricao">Parabéns, você concluiu todas as etapas e seu agente está pronto para ser testado.</div>
                <div className="space"></div>
                <img className="medical_image" src={icon_success}></img>
                <div className="space"></div>
                <span className="medical_success_01">O nome do seu agente é:</span>
                <span className="medical_success_04">{agent.nome}</span>
                <div className="space"></div>
                <span className="medical_success_01">Ele foi configurado na linha telefonica:</span>
                <span className="medical_success_04">{telefone}</span>
                <div className="space"></div>
                <span className="medical_success_01">E a agenda dele foi compartilhada com o email:&nbsp;<sup>1</sup></span>
                <span className="medical_success_04">{user.email}</span>
                <div className="space"></div>
                <span className="medical_success_03">Para testar e interagir com seu agente, basta dar um "oi" no WhatsApp para o número de telefone em que ele foi configurado.</span>
                <span className="space_form"></span>
                <span className="medical_success_02">Aproveite!<br />Você tem 7 dias gratuítos para testar seu agente</span>
                <div className="space"></div>
                <span className="medical_success_05">Observações da agenda</span>
                </>
                )}

            <div className="space"></div>
            <div className="space"></div>
            <div className="space"></div>
         
            </div>
        
        <Footer access={1}></Footer>
        
        </div>
    )
}